<template>
  <div>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :query="query"
      :selection="false"
      :toolbar="toolbar"
      label-width="100px"
    />
  </div>
</template>

<script>
import { getFirstNowLastDay } from '@/utils/tool'
import {
  HOST
} from '@/utils/host'
export default {
  data() {
    return {
      url: '/alarm/count/useCountlist',
      columns: [
        {
          label: '电桩名称',
          prop: 'equipmentName'
        }, {
          label: '归属电站',
          prop: 'stationName'
        }, {
          label: '电桩编码',
          prop: 'equipmentNum'
        }, {
          label: '枪数量(个)',
          prop: 'connectCount'
        }, {
          label: '投运日期',
          prop: 'setDate'
        }, {
          label: '使用次数',
          prop: 'orderCount'
        }, {
          label: '使用时长(小时)',
          prop: 'useDateLong'
        }
      ],
      query: [
        {
          label: '电桩名称',
          prop: 'equipName',
          placeholder: '请输入电桩名称'
        },
        {
          label: '所属电站',
          prop: 'stationName',
          placeholder: '请输入所属电站'
        },
        {
          label: '电桩编码',
          prop: 'equipNum',
          placeholder: '请输入电桩编码'
        },
        {
          label: '统计时间',
          prop: 'orderTime',
          placeholder: '',
          type: 'date3',
          haveValue: true,
          data: this.getFirstNowLastDay()
        },
        {
          label: '投运时间',
          prop: 'setTime',
          placeholder: '',
          type: 'date3'
        }
      ],
      toolbar: [
        {
          label: '导出',
          icon: 'el-icon-download',
          type: 'primary',
          handle: (resp) => {
            const url = HOST + '/alarm/count/exportCountlist'
            const data = this.$refs.tableref.getQueryData()
            $.fileDownload(url, {
              httpMethod: 'GET',
              data: {
                token: window.localStorage.getItem('token'),
                ...data
              },
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ]
    }
  },
  methods: {
    // 获取当前月起止日期
    getFirstNowLastDay() {
      const arr = getFirstNowLastDay()
      arr.splice(1, 1)
      return arr
    }
  }
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/views/statistics/pileUse.vue